// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file trade/v1/load_reconciliation.proto (package trade.v1, edition 2023)
// option features.field_presence = EXPLICIT;
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Decimal, ID, Money, Weight } from "../../types_pb.js";
import { file_types } from "../../types_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file trade/v1/load_reconciliation.proto.
 */
export const file_trade_v1_load_reconciliation: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_google_protobuf_empty, file_types]);

/**
 * LoadReconciliation represents the reconciliation data for a load
 *
 * @generated from message trade.v1.LoadReconciliation
 */
export type LoadReconciliation = Message<"trade.v1.LoadReconciliation"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string load_id = 2;
   */
  loadId: string;

  /**
   * Reconciliation data
   *
   * @generated from field: repeated trade.v1.ReceivedLineItem received_line_items = 3;
   */
  receivedLineItems: ReceivedLineItem[];

  /**
   * @generated from field: repeated trade.v1.ReconciliationDeduction deductions = 4;
   */
  deductions: ReconciliationDeduction[];

  /**
   * @generated from field: repeated trade.v1.FreightCharge freight_charges = 5;
   */
  freightCharges: FreightCharge[];

  /**
   * Receiving ticket fields (flattened from ReceivingTicket)
   *
   * @generated from field: string ticket_number = 6;
   */
  ticketNumber: string;

  /**
   * @generated from field: google.protobuf.Timestamp load_received_date = 7;
   */
  loadReceivedDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp ticket_issue_date = 8;
   */
  ticketIssueDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp mill_received_weight_post_date = 9;
   */
  millReceivedWeightPostDate?: Timestamp;

  /**
   * @generated from field: string external_notes = 10;
   */
  externalNotes: string;

  /**
   * Note: Files are now handled through files module federation
   *
   * @generated from field: string internal_notes = 11;
   */
  internalNotes: string;

  /**
   * Invoice reference
   *
   * @generated from field: string invoice_id = 12;
   */
  invoiceId: string;

  /**
   * Metadata
   *
   * @generated from field: string organization_id = 13;
   */
  organizationId: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 14;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 15;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string invoice_type = 16;
   */
  invoiceType: string;
};

/**
 * Describes the message trade.v1.LoadReconciliation.
 * Use `create(LoadReconciliationSchema)` to create a new message.
 */
export const LoadReconciliationSchema: GenMessage<LoadReconciliation> = /*@__PURE__*/
  messageDesc(file_trade_v1_load_reconciliation, 0);

/**
 * ReceivedLineItem represents what was actually received for a specific load line item
 *
 * @generated from message trade.v1.ReceivedLineItem
 */
export type ReceivedLineItem = Message<"trade.v1.ReceivedLineItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string load_line_item_id = 2;
   */
  loadLineItemId: string;

  /**
   * @generated from field: string material_type = 3;
   */
  materialType: string;

  /**
   * Denormalized fields from LoadLineItem
   *
   * @generated from field: string item_id = 11;
   */
  itemId: string;

  /**
   * @generated from field: string pricing_unit = 12;
   */
  pricingUnit: string;

  /**
   * Quantities
   *
   * @generated from field: types.Decimal gross_quantity = 4;
   */
  grossQuantity?: Decimal;

  /**
   * @generated from field: types.Decimal tare_quantity = 5;
   */
  tareQuantity?: Decimal;

  /**
   * Customer-reported quantities
   *
   * @generated from field: types.Decimal customer_gross_quantity = 13;
   */
  customerGrossQuantity?: Decimal;

  /**
   * @generated from field: types.Decimal customer_tare_quantity = 14;
   */
  customerTareQuantity?: Decimal;

  /**
   * Pricing
   *
   * @generated from field: types.Money unit_price = 6;
   */
  unitPrice?: Money;

  /**
   * @generated from field: types.Money customer_unit_price = 15;
   */
  customerUnitPrice?: Money;

  /**
   * Notes
   *
   * @generated from field: string notes = 7;
   */
  notes: string;

  /**
   * Metadata
   *
   * @generated from field: string organization_id = 8;
   */
  organizationId: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message trade.v1.ReceivedLineItem.
 * Use `create(ReceivedLineItemSchema)` to create a new message.
 */
export const ReceivedLineItemSchema: GenMessage<ReceivedLineItem> = /*@__PURE__*/
  messageDesc(file_trade_v1_load_reconciliation, 1);

/**
 * ReconciliationDeduction represents deductions applied during reconciliation
 *
 * @generated from message trade.v1.ReconciliationDeduction
 */
export type ReconciliationDeduction = Message<"trade.v1.ReconciliationDeduction"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string reconciliation_id = 2;
   */
  reconciliationId: string;

  /**
   * @generated from field: string load_line_item_id = 3;
   */
  loadLineItemId: string;

  /**
   * @generated from field: string received_line_item_id = 10;
   */
  receivedLineItemId: string;

  /**
   * @generated from field: string deduction_type_id = 4;
   */
  deductionTypeId: string;

  /**
   * @generated from field: types.Money price_quantity = 5;
   */
  priceQuantity?: Money;

  /**
   * @generated from field: types.Weight weight_quantity = 6;
   */
  weightQuantity?: Weight;

  /**
   * Metadata
   *
   * @generated from field: string organization_id = 7;
   */
  organizationId: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message trade.v1.ReconciliationDeduction.
 * Use `create(ReconciliationDeductionSchema)` to create a new message.
 */
export const ReconciliationDeductionSchema: GenMessage<ReconciliationDeduction> = /*@__PURE__*/
  messageDesc(file_trade_v1_load_reconciliation, 2);

/**
 * FreightCharge represents freight-related charges or credits
 *
 * @generated from message trade.v1.FreightCharge
 */
export type FreightCharge = Message<"trade.v1.FreightCharge"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string reconciliation_id = 2;
   */
  reconciliationId: string;

  /**
   * @generated from field: string hauler = 3;
   */
  hauler: string;

  /**
   * @generated from field: string freight_lane = 4;
   */
  freightLane: string;

  /**
   * @generated from field: string delivery_number = 5;
   */
  deliveryNumber: string;

  /**
   * @generated from field: types.Money accrued_amount = 6;
   */
  accruedAmount?: Money;

  /**
   * @generated from field: types.Money chargeback_amount = 7;
   */
  chargebackAmount?: Money;

  /**
   * Notes
   *
   * @generated from field: string notes = 8;
   */
  notes: string;

  /**
   * Metadata
   *
   * @generated from field: string organization_id = 9;
   */
  organizationId: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message trade.v1.FreightCharge.
 * Use `create(FreightChargeSchema)` to create a new message.
 */
export const FreightChargeSchema: GenMessage<FreightCharge> = /*@__PURE__*/
  messageDesc(file_trade_v1_load_reconciliation, 3);

/**
 * Update load reconciliation
 *
 * @generated from message trade.v1.UpdateLoadReconciliationRequest
 */
export type UpdateLoadReconciliationRequest = Message<"trade.v1.UpdateLoadReconciliationRequest"> & {
  /**
   * @generated from field: string reconciliation_id = 1;
   */
  reconciliationId: string;

  /**
   * @generated from field: repeated trade.v1.ReceivedLineItem received_line_items = 2;
   */
  receivedLineItems: ReceivedLineItem[];

  /**
   * @generated from field: repeated trade.v1.ReconciliationDeduction deductions = 3;
   */
  deductions: ReconciliationDeduction[];

  /**
   * @generated from field: repeated trade.v1.FreightCharge freight_charges = 4;
   */
  freightCharges: FreightCharge[];

  /**
   * Receiving ticket fields
   *
   * @generated from field: string ticket_number = 5;
   */
  ticketNumber: string;

  /**
   * @generated from field: google.protobuf.Timestamp load_received_date = 6;
   */
  loadReceivedDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp ticket_issue_date = 7;
   */
  ticketIssueDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp mill_received_weight_post_date = 8;
   */
  millReceivedWeightPostDate?: Timestamp;

  /**
   * @generated from field: string external_notes = 9;
   */
  externalNotes: string;

  /**
   * @generated from field: string internal_notes = 10;
   */
  internalNotes: string;

  /**
   * @generated from field: string organization_id = 11;
   */
  organizationId: string;

  /**
   * @generated from field: string invoice_type = 12;
   */
  invoiceType: string;
};

/**
 * Describes the message trade.v1.UpdateLoadReconciliationRequest.
 * Use `create(UpdateLoadReconciliationRequestSchema)` to create a new message.
 */
export const UpdateLoadReconciliationRequestSchema: GenMessage<UpdateLoadReconciliationRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_load_reconciliation, 4);

/**
 * @generated from message trade.v1.UpdateLoadReconciliationResponse
 */
export type UpdateLoadReconciliationResponse = Message<"trade.v1.UpdateLoadReconciliationResponse"> & {
  /**
   * @generated from field: trade.v1.LoadReconciliation reconciliation = 1;
   */
  reconciliation?: LoadReconciliation;
};

/**
 * Describes the message trade.v1.UpdateLoadReconciliationResponse.
 * Use `create(UpdateLoadReconciliationResponseSchema)` to create a new message.
 */
export const UpdateLoadReconciliationResponseSchema: GenMessage<UpdateLoadReconciliationResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_load_reconciliation, 5);

/**
 * Delete load reconciliation
 *
 * @generated from message trade.v1.DeleteLoadReconciliationRequest
 */
export type DeleteLoadReconciliationRequest = Message<"trade.v1.DeleteLoadReconciliationRequest"> & {
  /**
   * @generated from field: string reconciliation_id = 1;
   */
  reconciliationId: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;
};

/**
 * Describes the message trade.v1.DeleteLoadReconciliationRequest.
 * Use `create(DeleteLoadReconciliationRequestSchema)` to create a new message.
 */
export const DeleteLoadReconciliationRequestSchema: GenMessage<DeleteLoadReconciliationRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_load_reconciliation, 6);

/**
 * Get load reconciliation by ID
 *
 * @generated from message trade.v1.GetLoadReconciliationRequest
 */
export type GetLoadReconciliationRequest = Message<"trade.v1.GetLoadReconciliationRequest"> & {
  /**
   * @generated from field: repeated string reconciliation_ids = 1;
   */
  reconciliationIds: string[];

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;
};

/**
 * Describes the message trade.v1.GetLoadReconciliationRequest.
 * Use `create(GetLoadReconciliationRequestSchema)` to create a new message.
 */
export const GetLoadReconciliationRequestSchema: GenMessage<GetLoadReconciliationRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_load_reconciliation, 7);

/**
 * @generated from message trade.v1.GetLoadReconciliationResponse
 */
export type GetLoadReconciliationResponse = Message<"trade.v1.GetLoadReconciliationResponse"> & {
  /**
   * @generated from field: repeated trade.v1.LoadReconciliation reconciliations = 1;
   */
  reconciliations: LoadReconciliation[];
};

/**
 * Describes the message trade.v1.GetLoadReconciliationResponse.
 * Use `create(GetLoadReconciliationResponseSchema)` to create a new message.
 */
export const GetLoadReconciliationResponseSchema: GenMessage<GetLoadReconciliationResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_load_reconciliation, 8);

/**
 * List load reconciliations with filters
 *
 * @generated from message trade.v1.LoadReconciliationFilter
 */
export type LoadReconciliationFilter = Message<"trade.v1.LoadReconciliationFilter"> & {
  /**
   * @generated from field: repeated string reconciliation_ids = 1;
   */
  reconciliationIds: string[];

  /**
   * @generated from field: repeated string load_ids = 2;
   */
  loadIds: string[];

  /**
   * @generated from field: string organization_id = 3;
   */
  organizationId: string;

  /**
   * @generated from field: repeated types.ID created_by = 4;
   */
  createdBy: ID[];

  /**
   * @generated from field: repeated types.ID updated_by = 5;
   */
  updatedBy: ID[];
};

/**
 * Describes the message trade.v1.LoadReconciliationFilter.
 * Use `create(LoadReconciliationFilterSchema)` to create a new message.
 */
export const LoadReconciliationFilterSchema: GenMessage<LoadReconciliationFilter> = /*@__PURE__*/
  messageDesc(file_trade_v1_load_reconciliation, 9);

/**
 * @generated from message trade.v1.ListLoadReconciliationsRequest
 */
export type ListLoadReconciliationsRequest = Message<"trade.v1.ListLoadReconciliationsRequest"> & {
  /**
   * @generated from field: trade.v1.LoadReconciliationFilter filter = 1;
   */
  filter?: LoadReconciliationFilter;

  /**
   * @generated from field: int32 offset = 2;
   */
  offset: number;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;
};

/**
 * Describes the message trade.v1.ListLoadReconciliationsRequest.
 * Use `create(ListLoadReconciliationsRequestSchema)` to create a new message.
 */
export const ListLoadReconciliationsRequestSchema: GenMessage<ListLoadReconciliationsRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_load_reconciliation, 10);

/**
 * @generated from message trade.v1.ListLoadReconciliationsResponse
 */
export type ListLoadReconciliationsResponse = Message<"trade.v1.ListLoadReconciliationsResponse"> & {
  /**
   * @generated from field: repeated trade.v1.LoadReconciliation reconciliations = 1;
   */
  reconciliations: LoadReconciliation[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message trade.v1.ListLoadReconciliationsResponse.
 * Use `create(ListLoadReconciliationsResponseSchema)` to create a new message.
 */
export const ListLoadReconciliationsResponseSchema: GenMessage<ListLoadReconciliationsResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_load_reconciliation, 11);

/**
 * LoadReconciliationQueriesService provides read operations for load reconciliations
 *
 * @generated from service trade.v1.LoadReconciliationQueriesService
 */
export const LoadReconciliationQueriesService: GenService<{
  /**
   * Get load reconciliations by IDs
   *
   * @generated from rpc trade.v1.LoadReconciliationQueriesService.GetLoadReconciliation
   */
  getLoadReconciliation: {
    methodKind: "unary";
    input: typeof GetLoadReconciliationRequestSchema;
    output: typeof GetLoadReconciliationResponseSchema;
  },
  /**
   * List load reconciliations with filtering and pagination
   *
   * @generated from rpc trade.v1.LoadReconciliationQueriesService.ListLoadReconciliations
   */
  listLoadReconciliations: {
    methodKind: "unary";
    input: typeof ListLoadReconciliationsRequestSchema;
    output: typeof ListLoadReconciliationsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_trade_v1_load_reconciliation, 0);

/**
 * LoadReconciliationCommandsService provides write operations for load reconciliations
 *
 * @generated from service trade.v1.LoadReconciliationCommandsService
 */
export const LoadReconciliationCommandsService: GenService<{
  /**
   * Update an existing load reconciliation
   *
   * @generated from rpc trade.v1.LoadReconciliationCommandsService.UpdateLoadReconciliation
   */
  updateLoadReconciliation: {
    methodKind: "unary";
    input: typeof UpdateLoadReconciliationRequestSchema;
    output: typeof UpdateLoadReconciliationResponseSchema;
  },
  /**
   * Delete a load reconciliation
   *
   * @generated from rpc trade.v1.LoadReconciliationCommandsService.DeleteLoadReconciliation
   */
  deleteLoadReconciliation: {
    methodKind: "unary";
    input: typeof DeleteLoadReconciliationRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_trade_v1_load_reconciliation, 1);

